import { render, staticRenderFns } from "./EntityForm.vue?vue&type=template&id=3678551d&"
import script from "./EntityForm.vue?vue&type=script&lang=js&"
export * from "./EntityForm.vue?vue&type=script&lang=js&"
import style0 from "./EntityForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports